export const COURSES = [
  {
    lvl: 1,
    slug: "networking-essentials",
    stage: "FOUNDATION",
    title: "Networking Essentials",
    weeks: 4,
    mods: 16,
    labs: 16,
    price: "$49",
    was: "$99",
    difficulty: "Beginner",
    roles: ["blue", "red"],
    desc: "Security is applied networking. This level teaches you how data actually crosses a wire so that every attack and every alert later in the track makes sense.",
    modules: [
      "OSI and TCP/IP models",
      "IP addressing and subnetting",
      "Switching, VLANs and routing",
      "DNS, DHCP and HTTP(S) in depth",
      "Wireless, NAT and VPN basics",
      "Firewalls and network segmentation",
      "Packet analysis with Wireshark",
      "Network troubleshooting method",
      "Cloud networking primer",
      "Capture-and-explain lab",
      "AI \u00B7 How AI and LLM traffic looks on the wire",
      "AI \u00B7 Securing traffic to model APIs: TLS and egress control",
      "AI \u00B7 Machine-learning anomaly detection on networks, explained",
      "AI \u00B7 Using AI assistants to read packet captures",
      "AI \u00B7 Data leakage when you paste captures into AI tools",
      "AI \u00B7 AI-driven DDoS and automated traffic abuse",
    ],
    tools: ["Wireshark", "tcpdump", "Nmap", "Cisco Packet Tracer", "iptables"],
    cert: "CompTIA Network+ / CCNA aligned",
    capstone:
      "Analyse a supplied capture from a compromised office network and explain, packet by packet, what happened.",
    outcome:
      "Read a packet capture and describe exactly how traffic moves through an enterprise network.",
  },
  {
    lvl: 2,
    slug: "operating-systems-and-linux-fundamentals",
    stage: "FOUNDATION",
    title: "Operating Systems & Linux Fundamentals",
    weeks: 3,
    mods: 15,
    labs: 18,
    price: "$49",
    was: "$99",
    difficulty: "Beginner",
    roles: ["blue", "red"],
    desc: "Attackers and defenders both live at the command line. You build the Linux and Windows lab you will use for the remaining seven levels.",
    modules: [
      "Linux CLI and filesystem hierarchy",
      "Users, groups, permissions and sudo",
      "Processes, services and systemd",
      "Package management and hardening",
      "Windows internals and the registry",
      "Active Directory fundamentals",
      "PowerShell and Bash scripting starter",
      "Logging on both platforms",
      "Virtualisation and lab building",
      "AI \u00B7 Running a local LLM (Ollama) safely in your lab",
      "AI \u00B7 AI command-line copilots and their blast radius",
      "AI \u00B7 Hardening hosts that run AI workloads and model files",
      "AI \u00B7 Sandboxing AI agents with containers and namespaces",
      "AI \u00B7 Auditing what an AI agent did on a host",
      "AI \u00B7 AI-assisted log review on Linux and Windows",
    ],
    tools: [
      "Kali Linux",
      "Ubuntu Server",
      "Windows Server",
      "VirtualBox",
      "PowerShell",
      "Bash",
    ],
    cert: "CompTIA Linux+ / LFCS aligned",
    capstone:
      "Build a hardened two-OS home lab with a domain controller and document the build.",
    outcome:
      "Administer and harden Linux and Windows hosts, and stand up your own attack-and-defend lab.",
  },
  {
    lvl: 3,
    slug: "cybersecurity-essentials",
    stage: "FOUNDATION",
    title: "Cybersecurity Essentials",
    weeks: 4,
    mods: 17,
    labs: 14,
    price: "$49",
    was: "$99",
    difficulty: "Beginner to Intermediate",
    roles: ["blue", "grc"],
    desc: "The vocabulary, threat models and controls the whole industry assumes you already know. This is the level that makes you employable at entry tier and gets you your first certification.",
    modules: [
      "CIA triad and security models",
      "Threat actors and the attack lifecycle",
      "Cryptography in practice",
      "Identity, access management and MFA",
      "Endpoint and email defences",
      "Secure configuration baselines",
      "Vulnerabilities, CVEs and patching",
      "Security awareness and human risk",
      "Introduction to risk and compliance",
      "Cloud security shared responsibility",
      "Incident basics and escalation",
      "AI \u00B7 How AI changed the threat landscape",
      "AI \u00B7 Deepfake, voice-clone and AI phishing awareness",
      "AI \u00B7 Where AI helps in a security stack and where it misleads",
      "AI \u00B7 Shadow AI and acceptable-use policy basics",
      "AI \u00B7 Keeping sensitive data out of public AI tools",
      "AI \u00B7 Introduction to AI risk, NIST AI RMF and the EU AI Act",
    ],
    tools: [
      "OpenSSL",
      "Microsoft Defender",
      "Security Onion",
      "CIS Benchmarks",
      "Password managers",
    ],
    cert: "CompTIA Security+ / ISC2 CC aligned",
    capstone:
      "Assess a fictional 60-person company and deliver a prioritised set of security controls.",
    outcome:
      "Speak security fluently, pass your first industry certification and hold an entry-level security conversation.",
  },
  {
    lvl: 4,
    slug: "ethical-hacking-and-countermeasures",
    stage: "CORE",
    title: "Ethical Hacking & Countermeasures",
    weeks: 5,
    mods: 20,
    labs: 24,
    price: "$49",
    was: "$99",
    difficulty: "Intermediate",
    roles: ["red"],
    desc: "Offence taught properly: every attack you learn is paired with the control that stops it. You break the lab you built, then fix it.",
    modules: [
      "Reconnaissance and OSINT",
      "Scanning and enumeration",
      "Vulnerability assessment",
      "Password attacks and cracking",
      "System exploitation and privilege escalation",
      "Web application attacks: OWASP Top 10",
      "SQL injection and file upload abuse",
      "Wireless attacks",
      "Social engineering and phishing simulation",
      "Malware behaviour and evasion basics",
      "Living-off-the-land techniques",
      "Logging, detection and countermeasures",
      "Hardening and mitigation design",
      "Documenting findings",
      "AI \u00B7 AI-assisted reconnaissance and OSINT",
      "AI \u00B7 LLM-generated phishing and social engineering, and defences",
      "AI \u00B7 Prompt injection as an attack surface: first look",
      "AI \u00B7 Testing AI chat and copilot features in web apps",
      "AI \u00B7 Responsible AI-assisted payload and script generation",
      "AI \u00B7 Spotting AI-automated attacks in the lab",
    ],
    tools: [
      "Nmap",
      "Burp Suite",
      "Metasploit",
      "Hydra",
      "sqlmap",
      "Gobuster",
      "Nikto",
      "Hashcat",
    ],
    cert: "CEH aligned",
    capstone:
      "Compromise a vulnerable enterprise range end to end, then submit the remediation plan.",
    outcome:
      "Attack a realistic network legally and methodically \u2014 and write the fix for everything you found.",
  },
  {
    lvl: 5,
    slug: "penetration-testing-and-vulnerability-management",
    stage: "CORE",
    title: "Penetration Testing & Vulnerability Management",
    weeks: 6,
    mods: 22,
    labs: 28,
    price: "$49",
    was: "$99",
    difficulty: "Intermediate to Advanced",
    roles: ["red"],
    desc: "Hacking becomes a paid engagement: scoped, evidenced, reported and re-tested. This level also covers the unglamorous half nobody teaches \u2014 running vulnerability management at scale.",
    modules: [
      "Engagement scoping and rules of engagement",
      "Legal, ethics and client communication",
      "Network penetration testing methodology",
      "Active Directory attack paths",
      "Kerberos abuse and lateral movement",
      "Web and API penetration testing",
      "Authentication and business logic flaws",
      "Post-exploitation and pivoting",
      "Evidence collection and proof of concept",
      "Vulnerability management lifecycle",
      "Asset inventory and scanning programmes",
      "CVSS, EPSS and real prioritisation",
      "Remediation SLAs and exception handling",
      "Professional report writing",
      "Client debrief and retest",
      "Full-scope assessed engagement",
      "AI \u00B7 Scoping AI and LLM systems into an engagement",
      "AI \u00B7 Attacking LLM-backed application features",
      "AI \u00B7 Abusing model endpoints, API keys and quotas",
      "AI \u00B7 AI-assisted vulnerability triage and prioritisation",
      "AI \u00B7 Using LLMs to draft and quality-check reports safely",
      "AI \u00B7 Reporting AI-specific findings to a client",
    ],
    tools: [
      "Nessus",
      "Burp Suite Pro",
      "BloodHound",
      "Impacket",
      "NetExec",
      "Sliver",
      "Nuclei",
      "Responder",
    ],
    cert: "OSCP / CPTS / PNPT aligned",
    capstone:
      "Deliver a client-grade penetration test report on a live range, then defend it in a mock debrief.",
    outcome:
      "Run and report a professional penetration test, and manage vulnerabilities across a real asset estate.",
  },
  {
    lvl: 6,
    slug: "soc-analyst-and-threat-detection",
    stage: "CORE",
    title: "SOC Analyst & Threat Detection",
    weeks: 5,
    mods: 19,
    labs: 26,
    price: "$49",
    was: "$99",
    difficulty: "Intermediate",
    roles: ["blue"],
    desc: "The defensive side, where most first jobs are. You work simulated shifts in the lab range whenever you choose: alerts arrive, some are noise, one is an intrusion.",
    modules: [
      "SOC tiers, shifts and workflow",
      "Log sources, parsing and normalisation",
      "SIEM fundamentals and hunting queries",
      "MITRE ATT&CK mapping",
      "Detection engineering and Sigma rules",
      "Alert triage and false positive tuning",
      "EDR investigation",
      "Network traffic analysis for defenders",
      "Incident response lifecycle",
      "Containment, eradication, recovery",
      "Digital forensics and memory basics",
      "Threat intelligence enrichment",
      "Incident reporting and handover",
      "AI \u00B7 AI-assisted alert triage and case summarisation",
      "AI \u00B7 Machine learning anomaly detection and UEBA",
      "AI \u00B7 Detecting AI-generated phishing and deepfake fraud",
      "AI \u00B7 Hunting shadow AI usage in logs",
      "AI \u00B7 Monitoring LLM application and agent logs",
      "AI \u00B7 Writing detections with AI assistance, then validating them",
    ],
    tools: [
      "Splunk",
      "Microsoft Sentinel",
      "Elastic",
      "Wazuh",
      "Velociraptor",
      "TheHive",
      "MISP",
      "Sigma",
    ],
    cert: "CompTIA CySA+ / BTL1 aligned",
    capstone:
      "Run a graded simulated shift on demand: detect, triage, contain and report a multi-stage intrusion.",
    outcome:
      "Hold a Tier 1\u20132 SOC seat: triage realistic alerts, contain an intrusion and write the incident report.",
  },
  {
    lvl: 7,
    slug: "cybersecurity-grc",
    stage: "EXPERT",
    title: "Cybersecurity GRC",
    weeks: 6,
    mods: 18,
    labs: 12,
    price: "$75",
    was: "$149",
    difficulty: "Intermediate",
    roles: ["grc"],
    desc: "Governance, risk and compliance is where security meets the board and the regulator \u2014 and where salaries stop depending on how fast you type.",
    modules: [
      "Governance and security organisation design",
      "Building an ISO 27001 ISMS",
      "NIST CSF 2.0 and CIS Controls",
      "Risk assessment methodology and registers",
      "Control design and effectiveness testing",
      "Third-party and supply chain risk",
      "Internal audit and evidence collection",
      "Business continuity and DR",
      "Privacy: GDPR, India DPDP Act, GCC frameworks",
      "Policy and standard writing",
      "Security metrics and board reporting",
      "Compliance automation",
      "AI \u00B7 AI governance with NIST AI RMF and ISO/IEC 42001",
      "AI \u00B7 The EU AI Act and emerging regional AI rules",
      "AI \u00B7 AI risk assessments and model inventories",
      "AI \u00B7 Shadow AI discovery, approval workflow and controls",
      "AI \u00B7 Auditing AI vendors and the model supply chain",
      "AI \u00B7 Privacy and AI: training data, GDPR and the DPDP Act",
    ],
    tools: [
      "ISO 27001 toolkit",
      "NIST CSF 2.0",
      "CIS Controls v8",
      "Eramba",
      "Risk register models",
    ],
    cert: "ISO 27001 Lead Auditor / CISM / CRISC aligned",
    capstone:
      "Take a fictional fintech from zero to audit-ready: scope, risk register, controls, policies, board pack.",
    outcome:
      "Run a risk and compliance programme, survive an audit and explain security risk to executives.",
  },
  {
    lvl: 8,
    slug: "security-automation-and-python",
    stage: "EXPERT",
    title: "Security Automation & Python for Security",
    weeks: 6,
    mods: 17,
    labs: 22,
    price: "$75",
    was: "$149",
    difficulty: "Intermediate",
    roles: ["blue", "red"],
    desc: "The difference between an analyst and an engineer is what they automate. You stop repeating work and start shipping tools.",
    modules: [
      "Python for security engineers",
      "Working with APIs, JSON and auth",
      "Automating recon and scanning",
      "Log parsing and enrichment pipelines",
      "Building custom offensive tooling",
      "SOAR playbooks and case automation",
      "Git, code review and packaging",
      "Containers for security tooling",
      "Security checks in CI/CD",
      "Infrastructure as code guardrails",
      "Publishing and maintaining your tools",
      "AI \u00B7 Calling LLM APIs from security scripts",
      "AI \u00B7 Prompt engineering for security workflows",
      "AI \u00B7 Secrets, cost and rate-limit control for AI automation",
      "AI \u00B7 AI-assisted log enrichment and triage bots",
      "AI \u00B7 Agentic workflows with a human approval gate",
      "AI \u00B7 Evaluating and regression-testing AI output before you trust it",
    ],
    tools: [
      "Python",
      "Requests",
      "Scapy",
      "Git",
      "Docker",
      "GitHub Actions",
      "Terraform",
      "Shuffle SOAR",
    ],
    cert: "GIAC GPYC aligned + public code portfolio",
    capstone:
      "Ship three automations that remove documented manual toil from a security workflow.",
    outcome:
      "Automate detection, enrichment and testing work \u2014 the skill that turns an analyst into an engineer.",
  },
  {
    lvl: 9,
    slug: "ai-security",
    stage: "EXPERT",
    title: "AI Security",
    weeks: 7,
    mods: 18,
    labs: 20,
    price: "$75",
    was: "$149",
    difficulty: "Advanced",
    roles: ["ai", "red", "grc"],
    desc: "Every company is shipping AI faster than it can secure it. This level makes you the person who tests those systems and writes the guardrails.",
    modules: [
      "How LLM and ML systems are built",
      "OWASP Top 10 for LLM applications",
      "Prompt injection, direct and indirect",
      "Jailbreak and guardrail testing",
      "Training data poisoning and model extraction",
      "RAG pipeline and vector store security",
      "Agent and tool-use abuse",
      "Shadow AI discovery and governance",
      "AI red teaming methodology",
      "Securing AI in the SDLC",
      "NIST AI RMF and the EU AI Act",
      "Assessed AI red team engagement",
      "AI \u00B7 Adversarial machine learning and evasion attacks",
      "AI \u00B7 Securing the model supply chain and model weights",
      "AI \u00B7 Guardrail architecture and content filtering",
      "AI \u00B7 Multi-agent system threat modelling",
      "AI \u00B7 AI incident response and abuse monitoring",
      "AI \u00B7 Standing up an AI red team programme",
    ],
    tools: [
      "Garak",
      "PyRIT",
      "promptfoo",
      "LangChain",
      "Ollama",
      "Burp Suite",
      "Custom harnesses",
    ],
    cert: "AI Security Expert track, NIST AI RMF aligned",
    capstone:
      "Red team a production-style AI agent, then design the guardrails, monitoring and policy that hold it.",
    outcome:
      "Test AI systems for injection, poisoning and agent abuse \u2014 and govern them credibly afterwards.",
  },
  {
    lvl: 10,
    slug: "cloud-security",
    stage: "EXPERT",
    title: "Cloud Security",
    weeks: 6,
    mods: 18,
    labs: 20,
    price: "$75",
    was: "$149",
    difficulty: "Advanced",
    roles: ["blue", "red", "ai"],
    desc: "Almost every incident you will handle now starts in someone\u2019s cloud account \u2014 a public bucket, a leaked token, an over-permissive role. The final level takes you across AWS, Azure and GCP, containers, Kubernetes and the identity plane that holds them together.",
    modules: [
      "Cloud architecture and shared responsibility",
      "Cloud identity: IAM, roles and federation",
      "Securing AWS core services",
      "Securing Azure and Entra ID",
      "Google Cloud essentials for defenders",
      "Storage, secrets and key management",
      "Cloud network security and private connectivity",
      "Container and image supply chain security",
      "Kubernetes security and admission control",
      "Cloud logging, CSPM and posture management",
      "Attacking the cloud: privilege escalation paths",
      "Cloud incident response and forensics",
      "AI \u00B7 Securing managed AI services: Bedrock, Azure OpenAI, Vertex",
      "AI \u00B7 Hardening GPU nodes, model storage and inference endpoints",
      "AI \u00B7 Cloud detections for AI abuse and token theft",
      "AI \u00B7 Shadow AI discovery across cloud accounts",
      "AI \u00B7 AI-assisted cloud posture review and remediation",
      "AI \u00B7 Threat modelling an AI workload end to end",
    ],
    tools: [
      "AWS",
      "Azure",
      "Google Cloud",
      "Terraform",
      "Prowler",
      "ScoutSuite",
      "Trivy",
      "kube-bench",
    ],
    cert: "AWS Security Specialty / Microsoft SC-100 / CCSK aligned",
    capstone:
      "Assess a deliberately misconfigured multi-cloud estate, prove two escalation paths, then deliver the hardening plan.",
    outcome:
      "Secure and audit workloads across AWS, Azure and GCP \u2014 including the AI services running on them.",
  },
];

export const REGIONS = [
  {
    name: "Asia",
    pct: 92,
    note: "The largest talent pipeline and the fastest-growing SOC and GRC hiring market. India\u2019s CERT-In directions and the DPDP Act made security and privacy roles mandatory rather than optional, while banking, fintech and logistics hubs across Southeast Asia build first-generation security teams from scratch.",
  },
  {
    name: "Middle East / GCC",
    pct: 88,
    note: "National cyber strategies in Saudi Arabia and the UAE are funding roles faster than the region can fill them. Strongest pay for the experience.",
  },
  {
    name: "Europe",
    pct: 80,
    note: "NIS2, DORA and the EU AI Act turned security staffing into a legal requirement, especially for GRC, incident response and AI assurance.",
  },
  {
    name: "North America",
    pct: 85,
    note: "Highest salaries and the highest breach costs \u2014 an average of $10.22M per breach keeps demand structural.",
  },
  {
    name: "Africa",
    pct: 68,
    note: "Rapid digital banking and mobile money growth against a very thin trained workforce; remote hiring into EU and GCC teams is common.",
  },
];

export const SALARIES = [
  {
    role: "SOC Analyst (Tier 1\u20132)",
    unlock: "L6",
    entry: "$28k \u2013 $55k",
    senior: "$60k \u2013 $95k",
  },
  {
    role: "Penetration Tester",
    unlock: "L5",
    entry: "$45k \u2013 $85k",
    senior: "$95k \u2013 $150k",
  },
  {
    role: "Incident Responder / DFIR",
    unlock: "L6",
    entry: "$50k \u2013 $90k",
    senior: "$100k \u2013 $160k",
  },
  {
    role: "Security Engineer / Automation",
    unlock: "L8",
    entry: "$60k \u2013 $105k",
    senior: "$120k \u2013 $185k",
  },
  {
    role: "GRC / Risk & Compliance Lead",
    unlock: "L7",
    entry: "$45k \u2013 $85k",
    senior: "$100k \u2013 $170k",
  },
  {
    role: "AI Security Engineer",
    unlock: "L9",
    entry: "$85k \u2013 $140k",
    senior: "$150k \u2013 $240k",
  },
  {
    role: "Cloud Security Engineer",
    unlock: "L10",
    entry: "$60k \u2013 $110k",
    senior: "$130k \u2013 $210k",
  },
];

export const FAQS = [
  {
    q: "Is any part of this live, or in a classroom?",
    a: "No. The entire track is online and self-paced: recorded video lessons plus hands-on labs in your browser. There are no live classes, no scheduled webinars and no physical or offline centres. That is deliberate \u2014 a student in Manila, Riyadh, Lagos or Toronto gets exactly the same course at whatever hour suits them, and nobody falls behind a timetable.",
  },
  {
    q: "I have no IT background at all. Can I really start here?",
    a: "Yes \u2014 Level 1 begins at what a network is and assumes nothing else. Roughly half of our students come from non-technical degrees. What you need is about 10 focused hours a week and a willingness to sit in a terminal until something works. Because every lesson is recorded, you can rewind the hard parts as many times as you need.",
  },
  {
    q: "How long does the full track take?",
    a: "Around 52 weeks \u2014 a one-year programme at roughly 10 to 12 hours a week \u2014 but that is a suggested pace, not a schedule. There are no batch dates: you start the day you enrol, and motivated students with an IT background often finish far faster. Video and lab access lasts 18 months so life can interrupt without costing you the course.",
  },
  {
    q: "What does it cost, and do I have to buy all ten levels?",
    a: "Levels 1 to 6 are $49 each, reduced from $99. Levels 7 to 10 are $75 each, reduced from $149. The full ten-level track is $499 as a single one-time payment \u2014 less than buying the levels separately, and it includes the $49 CV Building and Mock Interview module free. The track is sequential but sold level by level, so working IT professionals can take the free placement test and buy only what they need; a single-level fee can be credited toward the full track within 60 days.",
  },
  {
    q: "What exactly is the cyber range, and what do I need to run it?",
    a: "A browser-based simulated company: domain controller, workstations, web applications, cloud accounts, a SIEM, an EDR and an AI application to attack. Everything runs in our infrastructure, so all you need is a laptop with a modern browser and a stable connection \u2014 no gaming rig, no VMs on your own machine, no VPN setup. 200 labs across the track, available 24/7.",
  },
  {
    q: "How much AI security is actually in the course?",
    a: "Level 9 is a full AI Security Expert specialisation, and every one of the other nine levels carries its own block of AI topics \u2014 from how model traffic looks on the wire in Level 1 to AI governance under the EU AI Act and ISO/IEC 42001 in Level 7. This is the part most syllabuses have not caught up with: you learn to use AI as a defender and to test the AI systems your future employer is already shipping.",
  },
  {
    q: "How do I get help if I am stuck, with no live sessions?",
    a: "Written walkthroughs and hint chains accompany every lab, and anything you cannot solve goes to our support queue and student community, where practitioners answer asynchronously. Your graded project submissions come back with written feedback \u2014 the report-writing correction that self-taught learners almost never get.",
  },
  {
    q: "What certificate do I get?",
    a: "After every level you sit an online exam \u2014 part multiple choice, part practical lab \u2014 and a pass earns a level certificate with a unique ID and a public verification link. Clear all ten levels, the ten graded projects and the final capstone and you are awarded the HD-CCE: the Hack Defense Certified Cybersecurity Expert, a one-year professional programme certificate.",
  },
  {
    q: "What is the free CV Building and Mock Interview module?",
    a: "A $49 module covering security-specific CV and LinkedIn rewriting, ATS keywords, how to package your ten graded projects as a portfolio, and a one-to-one mock technical interview with a practising security professional who sends you written feedback afterwards. It is included free with the full ten-level track, and anyone can buy it on its own \u2014 you do not have to have studied a single level with us.",
  },
  {
    q: "Will you help me get a job?",
    a: "From Level 6 onward, yes: written CV and LinkedIn review, recorded interview preparation, a technical question bank and referrals where we have them. We do not promise placement \u2014 anyone who guarantees you a job is selling something else.",
  },
];

export const STAGE_COLORS = {
  FOUNDATION: { fg: "#a3e635", bd: "rgba(163,230,53,0.35)" },
  CORE: { fg: "#e4e4e7", bd: "#3f3f46" },
  EXPERT: { fg: "#f5a5a5", bd: "rgba(245,165,165,0.35)" },
};

export const LEVEL_META = [
  {
    lvl: 1, slug: "networking-essentials", duration: "4 weeks",
    prereq: "Nothing. Level 1 is the start of the track.",
    prereqNote: "No IT background, no coding and no degree required.",
    nextSlug: "operating-systems-and-linux-fundamentals",
    nextTitle: "Level 2: Operating Systems & Linux Fundamentals",
    nextNote: "Unlocks once you pass this level\u2019s online exam.",
    roles: "Network Support, NOC Analyst, and every later security role in the track.",
  },
  {
    lvl: 2, slug: "operating-systems-and-linux-fundamentals", duration: "3 weeks",
    prereq: "Level 1: Networking Essentials",
    prereqNote: "You should understand TCP/IP, subnetting and packet analysis.",
    nextSlug: "cybersecurity-essentials",
    nextTitle: "Level 3: Cybersecurity Essentials",
    nextNote: "Unlocks once you pass this level\u2019s online exam.",
    roles: "Systems Administrator, Helpdesk Engineer, and the security track.",
  },
  {
    lvl: 3, slug: "cybersecurity-essentials", duration: "4 weeks",
    prereq: "Level 2: Operating Systems & Linux Fundamentals",
    prereqNote: "You should be comfortable administering Linux and Windows hosts.",
    nextSlug: "ethical-hacking-and-countermeasures",
    nextTitle: "Level 4: Ethical Hacking & Countermeasures",
    nextNote: "Unlocks once you pass this level\u2019s online exam.",
    roles: "Junior Security Analyst, IT Security Technician, GRC Assistant.",
  },
  {
    lvl: 4, slug: "ethical-hacking-and-countermeasures", duration: "5 weeks",
    prereq: "Level 3: Cybersecurity Essentials",
    prereqNote: "You should know threat models, controls and basic cryptography.",
    nextSlug: "penetration-testing-and-vulnerability-management",
    nextTitle: "Level 5: Penetration Testing & Vulnerability Management",
    nextNote: "Unlocks once you pass this level\u2019s online exam.",
    roles: "Junior Penetration Tester, Vulnerability Analyst, Security Analyst (offensive leaning).",
  },
  {
    lvl: 5, slug: "penetration-testing-and-vulnerability-management", duration: "6 weeks",
    prereq: "Level 4: Ethical Hacking & Countermeasures",
    prereqNote: "You should be able to exploit a vulnerable network and write a report.",
    nextSlug: "soc-analyst-and-threat-detection",
    nextTitle: "Level 6: SOC Analyst & Threat Detection",
    nextNote: "Unlocks once you pass this level\u2019s online exam.",
    roles: "Penetration Tester, Vulnerability Analyst, Red Team Junior.",
  },
  {
    lvl: 6, slug: "soc-analyst-and-threat-detection", duration: "5 weeks",
    prereq: "Level 5: Penetration Testing & Vulnerability Management",
    prereqNote: "You should understand scoping, exploitation and professional reporting.",
    nextSlug: "cybersecurity-grc",
    nextTitle: "Level 7: Cybersecurity GRC",
    nextNote: "Unlocks once you pass this level\u2019s online exam.",
    roles: "SOC Analyst (Tier 1\u20132), Incident Responder, Threat Hunter.",
  },
  {
    lvl: 7, slug: "cybersecurity-grc", duration: "6 weeks",
    prereq: "Level 6: SOC Analyst & Threat Detection",
    prereqNote: "You should be able to triage alerts and handle an incident.",
    nextSlug: "security-automation-and-python",
    nextTitle: "Level 8: Security Automation & Python for Security",
    nextNote: "Unlocks once you pass this level\u2019s online exam.",
    roles: "GRC Analyst, Compliance Analyst, Risk & Compliance Associate.",
  },
  {
    lvl: 8, slug: "security-automation-and-python", duration: "6 weeks",
    prereq: "Level 7: Cybersecurity GRC",
    prereqNote: "You should understand risk frameworks, controls and policy.",
    nextSlug: "ai-security",
    nextTitle: "Level 9: AI Security",
    nextNote: "Unlocks once you pass this level\u2019s online exam.",
    roles: "Security Engineer, Automation Engineer, Detection Engineer.",
  },
  {
    lvl: 9, slug: "ai-security", duration: "7 weeks",
    prereq: "Level 8: Security Automation & Python for Security",
    prereqNote: "You should be able to write Python scripts and automate security tasks.",
    nextSlug: "cloud-security",
    nextTitle: "Level 10: Cloud Security",
    nextNote: "Unlocks once you pass this level\u2019s online exam.",
    roles: "AI Security Analyst, AI Red Teamer, ML Security Specialist.",
  },
  {
    lvl: 10, slug: "cloud-security", duration: "6 weeks",
    prereq: "Level 9: AI Security",
    prereqNote: "You should understand LLM security, prompt injection and AI governance.",
    nextSlug: null,
    nextTitle: null,
    nextNote: null,
    roles: "Cloud Security Analyst, Cloud Security Engineer, Cloud Security Architect.",
  },
];

export const SLUG_TO_LVL = {
  "networking-essentials": 1,
  "operating-systems-and-linux-fundamentals": 2,
  "cybersecurity-essentials": 3,
  "ethical-hacking-and-countermeasures": 4,
  "penetration-testing-and-vulnerability-management": 5,
  "soc-analyst-and-threat-detection": 6,
  "cybersecurity-grc": 7,
  "security-automation-and-python": 8,
  "ai-security": 9,
  "cloud-security": 10,
};

export const LEVEL_FAQS = {
  1: [
    { q: "Do I need any networking knowledge before Level 1?", a: "None. Level 1 assumes you have never configured a router or opened Wireshark. It starts at what an IP address is and ends with you explaining a real attack packet by packet." },
    { q: "How long does Level 1 take and what does it cost?", a: "About 4 weeks at 10 to 12 hours a week, though it is fully self-paced so you can go faster. It costs $49, reduced from $99, and it is included in the $499 full ten-level track." },
    { q: "Is there an exam and a certificate for Level 1?", a: "Yes. The level ends in an online exam \u2014 part scenario questions, part a timed practical in the lab range. Pass it and your Level 1 certificate is issued immediately with a unique ID and a public verification link. One free retake is included." },
    { q: "Are there live classes?", a: "No. Every Hack Defense course is 100% online: recorded video lessons plus hands-on labs in your browser. There are no live sessions, no fixed batches and no offline centres, so you can study from any country at any hour." },
  ],
  2: [
    { q: "Do I need Linux experience before Level 2?", a: "No. Level 2 starts at the Linux command line and assumes you have never used it. If you have used Windows, you will be fine \u2014 the level covers both platforms." },
    { q: "How long does Level 2 take and what does it cost?", a: "About 3 weeks at 10 to 12 hours a week. It costs $49, reduced from $99, and is included in the $499 full track." },
    { q: "What will I build in Level 2?", a: "A hardened two-OS home lab with a Linux server and a Windows domain controller. This lab is the environment you will attack and defend for the rest of the track." },
    { q: "Do I need my own hardware?", a: "No. The labs run in our browser-based cyber range. You do not need to install anything on your own machine." },
  ],
  3: [
    { q: "What makes Level 3 different from other entry-level security courses?", a: "Level 3 covers the full security vocabulary \u2014 threat models, cryptography, IAM, compliance \u2014 and it includes AI security topics that most entry-level courses skip entirely. It also prepares you for CompTIA Security+ or ISC2 CC." },
    { q: "Can I skip to Level 3 if I already know the basics?", a: "Yes, if you can pass the placement test. Working IT professionals often start at Level 3 or 4." },
    { q: "What certification does Level 3 prepare me for?", a: "CompTIA Security+ or ISC2 CC. The course content is aligned to both exam objectives." },
    { q: "How much AI content is in Level 3?", a: "Six AI security modules covering the threat landscape, deepfake phishing, shadow AI policy, data leakage to AI tools, and an introduction to the NIST AI RMF and EU AI Act." },
  ],
  4: [
    { q: "Do I need to know programming for Level 4?", a: "No. Level 4 teaches you to use existing tools \u2014 Nmap, Burp Suite, Metasploit \u2014 not to write them. You will learn basic command-line usage but not software development." },
    { q: "Is this the same as CEH?", a: "The content is CEH-aligned, meaning it covers the same topics. But Level 4 includes hands-on labs and AI security material that CEH does not." },
    { q: "What will I be able to do after Level 4?", a: "Attack a realistic network legally and methodically, and write the fix for everything you found. You will be ready for junior penetration testing roles." },
    { q: "How is this different from Level 5?", a: "Level 4 teaches individual attacks. Level 5 teaches you to run a full engagement \u2014 scoping, reporting, retesting \u2014 and to manage vulnerabilities at scale." },
  ],
  5: [
    { q: "What is the difference between Level 4 and Level 5?", a: "Level 4 teaches individual attacks. Level 5 teaches you to run a complete penetration test engagement: scoping, rules of engagement, evidence collection, professional reporting and client debrief. It also covers vulnerability management at scale." },
    { q: "Does Level 5 prepare me for OSCP?", a: "Yes. The course content is aligned to OSCP, CPTS and PNPT exam objectives. The capstone is a full-scope assessed engagement similar to the OSCP exam." },
    { q: "How many labs are in Level 5?", a: "28 hands-on labs, the most of any level in the track. This is the level where you build real offensive skills." },
    { q: "Will I do real penetration testing?", a: "Yes. The capstone is a client-grade penetration test report on a live range, which you then defend in a mock debrief. This is the artefact you will show to employers." },
  ],
  6: [
    { q: "What does a SOC Analyst actually do?", a: "A SOC Analyst monitors security alerts, triages them to separate real threats from noise, investigates incidents and writes the incident report. Level 6 trains you for exactly this role." },
    { q: "Which SIEM tools will I learn?", a: "Splunk, Microsoft Sentinel, Elastic, Wazuh and Sigma for detection rules. You will also use Velociraptor for endpoint investigation and TheHive for case management." },
    { q: "Is this the right level for a blue team career?", a: "Yes. Level 6 is the primary blue team level. After completing it, you are ready for Tier 1\u20132 SOC analyst roles." },
    { q: "How much AI content is in Level 6?", a: "Six AI modules covering AI-assisted alert triage, machine learning anomaly detection (UEBA), detecting AI-generated phishing, hunting shadow AI usage, monitoring LLM application logs, and writing detections with AI assistance." },
  ],
  7: [
    { q: "Do I need to be a manager to take Level 7?", a: "No. Level 7 is for anyone who needs to understand governance, risk and compliance \u2014 which includes analysts, engineers and future managers. GRC knowledge is the fastest path to higher salaries." },
    { q: "What frameworks will I learn?", a: "ISO 27001, NIST CSF 2.0, CIS Controls v8, GDPR, the India DPDP Act, the EU AI Act, NIST AI RMF and ISO/IEC 42001." },
    { q: "Will I be able to run an audit?", a: "Yes. The capstone takes a fictional fintech from zero to audit-ready: scope, risk register, controls, policies and board pack. You will be able to survive an external audit." },
    { q: "Is GRC really that important?", a: "GRC is where security meets the board and the regulator. It is also where salaries stop depending on how fast you type and start depending on how well you think." },
  ],
  8: [
    { q: "Do I need to know Python before Level 8?", a: "No. Level 8 teaches Python from the security engineer\u2019s perspective. You will learn by building tools, not by doing exercises disconnected from real work." },
    { q: "What will I build?", a: "Three automations that remove documented manual toil from a security workflow. These go into your portfolio as proof you can ship tools." },
    { q: "What tools and frameworks will I use?", a: "Python, Requests, Scapy, Git, Docker, GitHub Actions, Terraform and Shuffle SOAR." },
    { q: "How does this help my career?", a: "The difference between an analyst and an engineer is what they automate. This level is the skill that gets you promoted." },
  ],
  9: [
    { q: "Do I need a machine learning background for Level 9?", a: "No. Level 9 starts at how LLM and ML systems are built and assumes no prior knowledge. You need to have completed Level 8 (Python) so you can write the automation scripts and test harnesses." },
    { q: "What will I learn to attack?", a: "Prompt injection, jailbreaks, training data poisoning, RAG pipeline abuse, agent and tool-use abuse, model extraction and shadow AI. You will red-team a production-style AI agent." },
    { q: "What guardrails will I learn to build?", a: "Content filtering, input validation, output monitoring, model supply chain security, incident response for AI abuse and a full AI red team programme." },
    { q: "How much demand is there for AI security roles?", a: "AI Security Engineer is the fastest-growing specialisation in cybersecurity. Entry ranges start at $85k\u2013$140k, with senior roles reaching $150k\u2013$240k." },
  ],
  10: [
    { q: "Which cloud providers does Level 10 cover?", a: "AWS, Azure and GCP. You will learn to secure workloads across all three, including the AI services running on them (Bedrock, Azure OpenAI, Vertex AI)." },
    { q: "Do I need cloud experience?", a: "No. Level 10 starts at cloud architecture and shared responsibility. But you should have completed Levels 1\u20139 so you have the networking, security and automation foundation." },
    { q: "What will the capstone involve?", a: "Assess a deliberately misconfigured multi-cloud estate, prove two privilege escalation paths, then deliver the hardening plan. This is the capstone of the entire track." },
    { q: "What certifications does this prepare me for?", a: "AWS Security Specialty, Microsoft SC-100 (Cybersecurity Architect Expert) and CCSK (Certificate of Cloud Security Knowledge)." },
  ],
};

export const ROLE_MAP = [
  {
    lane: "DEFENSIVE / BLUE",
    color: "#a3e635",
    entry: {
      title: "SOC Analyst, Tier 1",
      levels: "CLEAR L1\u2013L6",
      desc: "Alert triage, SIEM queries, escalation. The most common first security job on earth.",
    },
    mid: {
      title: "Incident Responder / Threat Hunter",
      levels: "ADD L8",
      desc: "Own the intrusion end to end, write detections, automate the boring half.",
    },
    senior: {
      title: "Detection Engineering Lead / SOC Manager",
      levels: "ADD L7",
      desc: "Design the detection strategy, run the team, answer to the board.",
    },
  },
  {
    lane: "OFFENSIVE / RED",
    color: "#e4e4e7",
    entry: {
      title: "Junior Penetration Tester",
      levels: "CLEAR L1\u2013L5",
      desc: "Scoped network and web tests under supervision, with real reports.",
    },
    mid: {
      title: "Penetration Tester / Red Teamer",
      levels: "ADD L8",
      desc: "Lead engagements, build tooling, chase Active Directory attack paths.",
    },
    senior: {
      title: "Offensive Security Lead / Consultant",
      levels: "ADD L9",
      desc: "Own client relationships, methodology and the AI red team practice.",
    },
  },
  {
    lane: "GOVERNANCE / GRC",
    color: "#f5a5a5",
    entry: {
      title: "IT Risk & Compliance Analyst",
      levels: "CLEAR L1\u2013L3 + L7",
      desc: "Control testing, evidence collection, vendor questionnaires, policy upkeep.",
    },
    mid: {
      title: "GRC Manager / ISO 27001 Lead Auditor",
      levels: "L7 + L3",
      desc: "Run the ISMS, own the risk register, survive external audits.",
    },
    senior: {
      title: "Head of Risk / CISO track",
      levels: "ADD L6 + L9",
      desc: "Set the security strategy and defend it in front of executives and regulators.",
    },
  },
  {
    lane: "AI SECURITY",
    color: "#facc15",
    entry: {
      title: "AI Security Analyst",
      levels: "CLEAR L1\u2013L4 + L9",
      desc: "Test AI features for prompt injection and data leakage; police shadow AI.",
    },
    mid: {
      title: "AI Red Teamer / ML Security Engineer",
      levels: "L8 + L9",
      desc: "Adversarial testing of models and agents, plus the guardrails that hold them.",
    },
    senior: {
      title: "Head of AI Security & Assurance",
      levels: "FULL TRACK",
      desc: "Own AI risk across the company, from engineering practice to the EU AI Act.",
    },
  },
  {
    lane: "CLOUD SECURITY",
    color: "#7dd3fc",
    entry: {
      title: "Cloud Security Analyst",
      levels: "CLEAR L1\u2013L3 + L10",
      desc: "Posture findings, IAM reviews, misconfiguration triage across AWS, Azure and GCP.",
    },
    mid: {
      title: "Cloud Security Engineer",
      levels: "L8 + L10",
      desc: "Build the guardrails: IaC policy, Kubernetes controls, automated remediation.",
    },
    senior: {
      title: "Cloud Security Architect",
      levels: "FULL TRACK",
      desc: "Own the design of a secure multi-cloud estate, AI workloads included.",
    },
  },
];
